export const scrollTo = (x = 0, y = 0) => {
  window.scrollTo(x, y);
};



// WEBPACK FOOTER //
// ./utils/scrollHandler.js